module.exports = __webpack_public_path__ + "static/img/gxg.b6e2b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg.png
// module id = swfx
// module chunks = 46